import React, { useState, useEffect } from "react";
import Classes from "./styles/style.module.css";
import { useSelector } from "react-redux";

const UserLevelProgress = () => {
  const { minScore, maxScore, userScore } = useSelector(({ user }) => user);
  const [progress, setprogress] = useState(0);

  const calculateProgress = (minScore, maxScore, userScore) => {
    const range = maxScore - minScore;
    const scoreINLevel = userScore - minScore;
    const levelInPercentage = (scoreINLevel / range) * 100;
    setprogress(levelInPercentage);
  };

  useEffect(() => {
    calculateProgress(minScore, maxScore, userScore);
  }, [minScore, maxScore, userScore]);

  return (
    <div className={Classes.userRateContainer}>
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          borderRadius: "100px",
          background: "var(--alertColor)",
          transition: "width 0.5s ease-in-out",
        }}
      >
        {progress >= 25 && (
          <div className="d-flex justify-content-end">
            <span className={Classes.peleText}>پله</span>
            <p className={Classes.progressText}>{userScore}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserLevelProgress;
